<mat-chip
  (removed)="onRemove()"
  [ngClass]="{
    removable: !removable,
    commissioner: isCommissioner,
  }"
  (click)="handleClickOrKeyPress($event)"
  (keypress)="handleClickOrKeyPress($event)"
  >
  {{ tag.name }}
  @if (removable) {
    <button matChipRemove [attr.aria-label]="'remove ' + tag">
      <mat-icon svgIcon="cancel_filled"></mat-icon>
    </button>
  }
</mat-chip>
